import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/sIcon.png'
import _imports_1 from '@/assets/uIcon.png'


const _withScopeId = n => (_pushScopeId("data-v-4b17d419"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "unsch-content-loading",
  class: "text-center mt-3"
}
const _hoisted_2 = { class: "fa-2x" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1))
const _hoisted_4 = {
  key: 0,
  id: "unsch-content"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-2 txtLeft" }, [
  /*#__PURE__*/_createElementVNode("b", null, "AVAILABLE STAFF - Employees who worked in the last 12 hours are not displayed")
], -1))
const _hoisted_6 = { id: "grdUnscheduled" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "associaionIcon",
  title: "Secondary Association"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "associaionIcon",
  title: "Unassociated"
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  id: "unsch-message",
  class: "text-center mt-3"
}
const _hoisted_15 = { id: "unsch-message-text" }
const _hoisted_16 = {
  key: 2,
  id: "unavailableStaff-content",
  class: "mt-3"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-2 txtLeft" }, [
  /*#__PURE__*/_createElementVNode("b", null, "UNAVAILABLE STAFF")
], -1))
const _hoisted_18 = { id: "grdUnavailableStaff" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "associaionIcon",
  title: "Secondary Association"
}, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { key: 2 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "associaionIcon",
  title: "Unassociated"
}, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 3,
  id: "unavailable-message",
  class: "text-center mt-3"
}
const _hoisted_27 = { id: "unavailable-message-text" }
const _hoisted_28 = {
  id: "filterModel_avail",
  class: "filterPanel d-none"
}
const _hoisted_29 = { class: "p-2" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-2" }, "Filter by: ", -1))
const _hoisted_31 = ["value"]
const _hoisted_32 = ["value"]
const _hoisted_33 = ["value"]
const _hoisted_34 = { key: 6 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox-label" }, " All ", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "checkbox-label" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox-label" }, " All ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "checkbox-label" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox-label" }, " All ", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_49 = ["value"]
const _hoisted_50 = { class: "checkbox-label" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_53 = {
  id: "filterModel_unavail",
  class: "filterPanel d-none"
}
const _hoisted_54 = { class: "p-2" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-2" }, "Filter by: ", -1))
const _hoisted_56 = ["value"]
const _hoisted_57 = ["value"]
const _hoisted_58 = ["value"]
const _hoisted_59 = { key: 6 }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox-label" }, " All ", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_62 = ["value"]
const _hoisted_63 = { class: "checkbox-label" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox-label" }, " All ", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_68 = ["value"]
const _hoisted_69 = { class: "checkbox-label" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox-label" }, " All ", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_74 = ["value"]
const _hoisted_75 = { class: "checkbox-label" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_78 = { key: 4 }
const _hoisted_79 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_table_heading = _resolveComponent("neu-table-heading")!
  const _component_neu_table_row = _resolveComponent("neu-table-row")!
  const _component_neu_label = _resolveComponent("neu-label")!
  const _component_neu_table_body = _resolveComponent("neu-table-body")!
  const _component_neu_table = _resolveComponent("neu-table")!
  const _component_neu_card = _resolveComponent("neu-card")!
  const _component_neu_icon = _resolveComponent("neu-icon")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!
  const _component_ExportToExcelForTabs = _resolveComponent("ExportToExcelForTabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_font_awesome_icon, {
          spin: true,
          icon: ['fas', 'circle-notch'],
          size: "lg"
        })
      ]),
      _hoisted_3
    ], 512), [
      [_vShow, _ctx.isShowLoader]
    ]),
    (_ctx.isShowAvailStaffContent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              id: "sms-notification-modal-btn",
              class: "btn btn-primary btn-sm float-end me-2",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showSendSMSPopup && _ctx.showSendSMSPopup(...args)))
            }, "SEND SMS")
          ]),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_neu_card, {
              color: "plain-0",
              class: "p-0 m-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_neu_table, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_neu_table_row, {
                      columns: _ctx.columnHeadersAvail,
                      header: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeadersAvail), (column) => {
                          return (_openBlock(), _createBlock(_component_neu_table_heading, {
                            icon: _ctx.columnIcons[column],
                            key: column,
                            slot: column,
                            style: {"padding-top":"25px !important"},
                            onVNeuChange: ($event: any) => (_ctx.sortDataAvailable($event,column))
                          }, {
                            default: _withCtx(() => [
                              ((column != 'RN Experience' || (column == 'RN Experience' && _ctx.isRNExperienceFeatureEnabled)))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("span", null, _toDisplayString(column), 1),
                                    (_ctx.filterColumnList.includes(column))
                                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                          key: 0,
                                          icon: ['fas', 'filter'],
                                          size: "lg",
                                          id: "filterIcon",
                                          column: column,
                                          onClick: ($event: any) => (_ctx.onFilterVisible($event, column,'avail')),
                                          style: {"margin-left":"5px"}
                                        }, null, 8, ["column", "onClick"]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["icon", "slot", "onVNeuChange"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["columns"]),
                    _createVNode(_component_neu_table_body, { align: "left" }, {
                      default: _withCtx(() => [
                        (_ctx.availGridData != null && _ctx.availGridData.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.availGridData, (dataItem) => {
                              return (_openBlock(), _createBlock(_component_neu_table_row, {
                                columns: _ctx.columnHeadersAvail,
                                slot: _ctx.column,
                                key: dataItem,
                                onClick: ($event: any) => (_ctx.onRowSelect(dataItem)),
                                class: _normalizeClass([dataItem.charge ? 'chargeAssignment': '']),
                                "data-staffId": dataItem.staffId
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_neu_label, {
                                    slot: "Name",
                                    title: _ctx.getName(dataItem)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.getName(dataItem)) + " ", 1),
                                      (dataItem.charge)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                            _createVNode(_component_font_awesome_icon, {
                                              icon: ['fa', 'user-md'],
                                              size: "sm",
                                              style: {"float":"right","font-size":"16px"}
                                            })
                                          ]))
                                        : _createCommentVNode("", true),
                                      (dataItem.associationType === _ctx.associationTypes.secondary)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _hoisted_10))
                                        : _createCommentVNode("", true),
                                      (dataItem.associationType === _ctx.associationTypes.unassociated)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _hoisted_13))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["title"]),
                                  _createVNode(_component_neu_label, {
                                    slot: "Skill",
                                    title: dataItem.skillDescription
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.skillDescription), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["title"]),
                                  _createVNode(_component_neu_label, {
                                    slot: "Comps",
                                    style: {"white-space":"nowrap"},
                                    class: "col-comps"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.competencies.length > 0 ? dataItem.competencyCodes : ''), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "Type" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.employeeType), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, {
                                    slot: "Worked Hrs",
                                    class: _normalizeClass([dataItem.hoursWorked > dataItem.hours ? 'gridOverTime': ''])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.hoursWorked), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["class"]),
                                  _createVNode(_component_neu_label, { slot: "Sched. Hrs" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.hours), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (dataItem.rnExperienceFeatureEnabled)
                                    ? (_openBlock(), _createBlock(_component_neu_label, {
                                        key: 0,
                                        slot: "RN Experience",
                                        class: _normalizeClass([dataItem.rnExperience == '< 1 Year' ? 'rn-experience': '']),
                                        title: dataItem.rnExperience
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(dataItem.rnExperience), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class", "title"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_neu_label, { slot: "Hire Date" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.hireDate)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "Seniority Date" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.seniorityDate)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "Last Worked Date" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.lastWorked)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "Last Worked Time" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridTimeFormat(dataItem.lastWorked)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "Next Assignment Date" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.nextAssignmentDate)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "Next Assignment Time" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridTimeFormat(dataItem.nextAssignmentStart)), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["columns", "slot", "onClick", "class", "data-staffId"]))
                            }), 128))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowAvailMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.unschMessage), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowUnavailStaffContent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_neu_card, {
              color: "plain-0",
              class: "p-0 m-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_neu_table, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_neu_table_row, {
                      columns: _ctx.columnHeadersUnavail,
                      header: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeadersUnavail), (column) => {
                          return (_openBlock(), _createBlock(_component_neu_table_heading, {
                            icon: _ctx.columnIcons[column],
                            key: column,
                            slot: column,
                            style: {"padding-top":"25px !important"},
                            onVNeuChange: ($event: any) => (_ctx.sortDataUnavailable($event,column))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(column), 1),
                              (_ctx.filterColumnList.includes(column))
                                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 0,
                                    icon: ['fas', 'filter'],
                                    size: "lg",
                                    id: "filterIcon",
                                    column: column,
                                    onClick: ($event: any) => (_ctx.onFilterVisible($event, column,'unavail')),
                                    style: {"margin-left":"5px"}
                                  }, null, 8, ["column", "onClick"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["icon", "slot", "onVNeuChange"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["columns"]),
                    _createVNode(_component_neu_table_body, { align: "left" }, {
                      default: _withCtx(() => [
                        (_ctx.unavailGridData != null && _ctx.unavailGridData.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.unavailGridData, (dataItem) => {
                              return (_openBlock(), _createBlock(_component_neu_table_row, {
                                columns: _ctx.columnHeadersUnavail,
                                slot: _ctx.column,
                                key: dataItem,
                                onClick: ($event: any) => (_ctx.onRowSelect(dataItem)),
                                class: _normalizeClass([dataItem.charge ? 'chargeAssignment': '']),
                                "data-staffId": dataItem.staffId
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_neu_label, {
                                    slot: "Name",
                                    title: _ctx.getName(dataItem)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.getName(dataItem)) + " ", 1),
                                      (dataItem.charge)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                            _createVNode(_component_font_awesome_icon, {
                                              icon: ['fa', 'user-md'],
                                              size: "sm",
                                              style: {"float":"right","font-size":"16px"}
                                            })
                                          ]))
                                        : _createCommentVNode("", true),
                                      (dataItem.associationType === _ctx.associationTypes.secondary)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _hoisted_22))
                                        : _createCommentVNode("", true),
                                      (dataItem.associationType === _ctx.associationTypes.unassociated)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, _hoisted_25))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["title"]),
                                  _createVNode(_component_neu_label, {
                                    slot: "Skill",
                                    title: dataItem.skillDescription
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.skillDescription), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["title"]),
                                  _createVNode(_component_neu_label, {
                                    slot: "Comps",
                                    style: {"white-space":"nowrap"},
                                    class: "col-comps"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.competencies.length > 0 ? dataItem.competencyCodes : ''), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "Type" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.employeeType), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, {
                                    slot: "Worked Hrs",
                                    class: _normalizeClass([dataItem.hoursWorked > dataItem.hours ? 'gridOverTime': ''])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.hoursWorked), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["class"]),
                                  _createVNode(_component_neu_label, { slot: "Sched. Hrs" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.hours), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "Hire Date" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.hireDate)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "Seniority Date" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.seniorityDate)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "Last Worked Date" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.lastWorked)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "Last Worked Time" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridTimeFormat(dataItem.lastWorked)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "Next Assignment Date" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.nextAssignmentDate)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "Next Assignment Time" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridTimeFormat(dataItem.nextAssignmentStart)), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["columns", "slot", "onClick", "class", "data-staffId"]))
                            }), 128))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowUnavailMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.unavailMessage), 1)
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        (_ctx.filterColumn_avail == 'Worked Hrs' || _ctx.filterColumn_avail == 'Sched. Hrs')
          ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 0,
              "data-role": "dropdownlist",
              class: "neu-select mb-2 filterInput",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedNumberFilter_avail) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numberFilter, (numFtr) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: numFtr.Id,
                  key: numFtr.Id
                }, _toDisplayString(numFtr.Value), 9, _hoisted_31))
              }), 128))
            ], 512)), [
              [_vModelSelect, _ctx.selectedNumberFilter_avail]
            ])
          : (_ctx.filterColumn_avail == 'Last Worked Date' || _ctx.filterColumn_avail == 'Next Assignment Date')
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 1,
                "data-role": "dropdownlist",
                class: "neu-select mb-2 filterInput",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedDateFilter_avail) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateFilter, (dateFtr) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: dateFtr.Id,
                    key: dateFtr.Id
                  }, _toDisplayString(dateFtr.Value), 9, _hoisted_32))
                }), 128))
              ], 512)), [
                [_vModelSelect, _ctx.selectedDateFilter_avail]
              ])
            : (_ctx.filterColumn_avail != 'Type' && _ctx.filterColumn_avail != 'Last Worked Time' && _ctx.filterColumn_avail != 'Next Assignment Time')
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 2,
                  "data-role": "dropdownlist",
                  class: "neu-select mb-2 filterInput",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedTextFilter_avail) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textFilter, (txtFtr) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: txtFtr.Id,
                      key: txtFtr.Id
                    }, _toDisplayString(txtFtr.Value), 9, _hoisted_33))
                  }), 128))
                ], 512)), [
                  [_vModelSelect, _ctx.selectedTextFilter_avail]
                ])
              : _createCommentVNode("", true),
        (_ctx.filterColumn_avail != 'Type' && _ctx.filterColumn_avail != 'Last Worked Time' && _ctx.filterColumn_avail != 'Next Assignment Time')
          ? (_openBlock(), _createBlock(_component_neu_icon, {
              key: 3,
              class: "material-icons neu-input__select-icon z-max"
            }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.filterColumn_avail == 'Worked Hrs' || _ctx.filterColumn_avail == 'Sched. Hrs')
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 4,
              title: "Value",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.NumberfilterText_avail) = $event)),
              class: "neu-input mb-2 filterInput",
              type: "number"
            }, null, 512)), [
              [_vModelText, _ctx.NumberfilterText_avail]
            ])
          : (_ctx.filterColumn_avail == 'Last Worked Date' || _ctx.filterColumn_avail == 'Next Assignment Date')
            ? (_openBlock(), _createBlock(_component_Datepicker, {
                key: 5,
                modelValue: _ctx.DateFilterText_avail,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.DateFilterText_avail) = $event)),
                weekStart: "0",
                enableTimePicker: false,
                autoApply: ""
              }, null, 8, ["modelValue"]))
            : (_ctx.filterColumn_avail == 'Type' || _ctx.filterColumn_avail == 'Last Worked Time' || _ctx.filterColumn_avail == 'Next Assignment Time')
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  (_ctx.filterColumn_avail == 'Type')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.checkAllTypeFilter())),
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isCheckAllTypeFilter_avail) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.isCheckAllTypeFilter_avail]
                        ]),
                        _hoisted_35,
                        _hoisted_36,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lstType_avail, (itemT, index) => {
                          return (_openBlock(), _createElementBlock("span", { key: index }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: itemT,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedTypeFilter_avail) = $event)),
                              onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateCheckallTypeFilter()))
                            }, null, 40, _hoisted_37), [
                              [_vModelCheckbox, _ctx.selectedTypeFilter_avail]
                            ]),
                            _createTextVNode(),
                            _createElementVNode("span", _hoisted_38, _toDisplayString(itemT), 1),
                            _createTextVNode(),
                            _hoisted_39
                          ]))
                        }), 128)),
                        _hoisted_40,
                        _createElementVNode("span", null, _toDisplayString(_ctx.selectedTypeFilter_avail.length) + " items selected", 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.filterColumn_avail == 'Last Worked Time')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.checkAllLastWorkTimeFilter())),
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isCheckAllWorkTimeFilter_avail) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.isCheckAllWorkTimeFilter_avail]
                        ]),
                        _hoisted_41,
                        _hoisted_42,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lstLastWorkedTime_avail, (itemL, index) => {
                          return (_openBlock(), _createElementBlock("span", { key: index }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: itemL,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedLastWorkTimeFilter_avail) = $event)),
                              onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateCheckAllLastWorkTimeFilter()))
                            }, null, 40, _hoisted_43), [
                              [_vModelCheckbox, _ctx.selectedLastWorkTimeFilter_avail]
                            ]),
                            _createTextVNode(),
                            _createElementVNode("span", _hoisted_44, _toDisplayString(itemL), 1),
                            _createTextVNode(),
                            _hoisted_45
                          ]))
                        }), 128)),
                        _hoisted_46,
                        _createElementVNode("span", null, _toDisplayString(_ctx.selectedLastWorkTimeFilter_avail.length) + " items selected", 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.filterColumn_avail == 'Next Assignment Time')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.checkAllNextAssigmentTimeFilter())),
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.isCheckAllNextAssignTimeFilter_avail) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.isCheckAllNextAssignTimeFilter_avail]
                        ]),
                        _hoisted_47,
                        _hoisted_48,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lstNextAssignmentTime_avail, (itemN, index) => {
                          return (_openBlock(), _createElementBlock("span", { key: index }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: itemN,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedNextAssignementTimeFilter_avail) = $event)),
                              onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.updateCheckAllNextAssignTimeFilter()))
                            }, null, 40, _hoisted_49), [
                              [_vModelCheckbox, _ctx.selectedNextAssignementTimeFilter_avail]
                            ]),
                            _createTextVNode(),
                            _createElementVNode("span", _hoisted_50, _toDisplayString(itemN), 1),
                            _createTextVNode(),
                            _hoisted_51
                          ]))
                        }), 128)),
                        _hoisted_52,
                        _createElementVNode("span", null, _toDisplayString(_ctx.selectedNextAssignementTimeFilter_avail.length) + " items selected", 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 7,
                  title: "Value",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.filterText_avail) = $event)),
                  class: "neu-input mb-2 filterInput",
                  type: "text"
                }, null, 512)), [
                  [_vModelText, _ctx.filterText_avail]
                ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "submit",
            title: "Filter",
            class: "neu-button--primary neu-button neu-button--raised filterBtn",
            onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.onGridFilter && _ctx.onGridFilter(...args)))
          }, "Filter"),
          _createElementVNode("button", {
            type: "reset",
            title: "Clear",
            class: "neu-button--primary neu-button neu-button--raised filterBtn",
            onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.onGridFilterClear && _ctx.onGridFilterClear(...args)))
          }, "Clear"),
          _createElementVNode("button", {
            type: "button",
            title: "Close",
            class: "neu-button--primary neu-button neu-button--raised filterBtn",
            onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.onGridFilterClose && _ctx.onGridFilterClose(...args)))
          }, "Close")
        ])
      ])
    ], 512), [
      [_vShow, _ctx.filterVisibleOnGrid == 'avail']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_53, [
      _createElementVNode("div", _hoisted_54, [
        _hoisted_55,
        (_ctx.filterColumn_unavail == 'Worked Hrs' || _ctx.filterColumn_unavail == 'Sched. Hrs')
          ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 0,
              "data-role": "dropdownlist",
              class: "neu-select mb-2 filterInput",
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.selectedNumberFilter_unavail) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numberFilter, (numFtr) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: numFtr.Id,
                  key: numFtr.Id
                }, _toDisplayString(numFtr.Value), 9, _hoisted_56))
              }), 128))
            ], 512)), [
              [_vModelSelect, _ctx.selectedNumberFilter_unavail]
            ])
          : (_ctx.filterColumn_unavail == 'Last Worked Date' || _ctx.filterColumn_unavail == 'Next Assignment Date')
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 1,
                "data-role": "dropdownlist",
                class: "neu-select mb-2 filterInput",
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.selectedDateFilter_unavail) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateFilter, (dateFtr) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: dateFtr.Id,
                    key: dateFtr.Id
                  }, _toDisplayString(dateFtr.Value), 9, _hoisted_57))
                }), 128))
              ], 512)), [
                [_vModelSelect, _ctx.selectedDateFilter_unavail]
              ])
            : (_ctx.filterColumn_unavail != 'Type' && _ctx.filterColumn_unavail != 'Last Worked Time' && _ctx.filterColumn_unavail != 'Next Assignment Time')
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 2,
                  "data-role": "dropdownlist",
                  class: "neu-select mb-2 filterInput",
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.selectedTextFilter_unavail) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textFilter, (txtFtr) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: txtFtr.Id,
                      key: txtFtr.Id
                    }, _toDisplayString(txtFtr.Value), 9, _hoisted_58))
                  }), 128))
                ], 512)), [
                  [_vModelSelect, _ctx.selectedTextFilter_unavail]
                ])
              : _createCommentVNode("", true),
        (_ctx.filterColumn_unavail != 'Type' && _ctx.filterColumn_unavail != 'Last Worked Time' && _ctx.filterColumn_unavail != 'Next Assignment Time')
          ? (_openBlock(), _createBlock(_component_neu_icon, {
              key: 3,
              class: "material-icons neu-input__select-icon z-max"
            }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.filterColumn_unavail == 'Worked Hrs' || _ctx.filterColumn_unavail == 'Sched. Hrs')
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 4,
              title: "Value",
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.NumberfilterText_unavail) = $event)),
              class: "neu-input mb-2 filterInput",
              type: "number"
            }, null, 512)), [
              [_vModelText, _ctx.NumberfilterText_unavail]
            ])
          : (_ctx.filterColumn_unavail == 'Last Worked Date' || _ctx.filterColumn_unavail == 'Next Assignment Date')
            ? (_openBlock(), _createBlock(_component_Datepicker, {
                key: 5,
                modelValue: _ctx.DateFilterText_unavail,
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.DateFilterText_unavail) = $event)),
                weekStart: "0",
                enableTimePicker: false,
                autoApply: ""
              }, null, 8, ["modelValue"]))
            : (_ctx.filterColumn_unavail == 'Type' || _ctx.filterColumn_unavail == 'Last Worked Time' || _ctx.filterColumn_unavail == 'Next Assignment Time')
              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                  (_ctx.filterColumn_unavail == 'Type')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.checkAllTypeFilter())),
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.isCheckAllTypeFilter_unavail) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.isCheckAllTypeFilter_unavail]
                        ]),
                        _hoisted_60,
                        _hoisted_61,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lstType_unavail, (itemT, index) => {
                          return (_openBlock(), _createElementBlock("span", { key: index }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: itemT,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.selectedTypeFilter_unavail) = $event)),
                              onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.updateCheckallTypeFilter()))
                            }, null, 40, _hoisted_62), [
                              [_vModelCheckbox, _ctx.selectedTypeFilter_unavail]
                            ]),
                            _createTextVNode(),
                            _createElementVNode("span", _hoisted_63, _toDisplayString(itemT), 1),
                            _createTextVNode(),
                            _hoisted_64
                          ]))
                        }), 128)),
                        _hoisted_65,
                        _createElementVNode("span", null, _toDisplayString(_ctx.selectedTypeFilter_unavail.length) + " items selected", 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.filterColumn_unavail == 'Last Worked Time')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.checkAllLastWorkTimeFilter())),
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.isCheckAllWorkTimeFilter_unavail) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.isCheckAllWorkTimeFilter_unavail]
                        ]),
                        _hoisted_66,
                        _hoisted_67,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lstLastWorkedTime_unavail, (itemL, index) => {
                          return (_openBlock(), _createElementBlock("span", { key: index }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: itemL,
                              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.selectedLastWorkTimeFilter_unavail) = $event)),
                              onChange: _cache[34] || (_cache[34] = ($event: any) => (_ctx.updateCheckAllLastWorkTimeFilter()))
                            }, null, 40, _hoisted_68), [
                              [_vModelCheckbox, _ctx.selectedLastWorkTimeFilter_unavail]
                            ]),
                            _createTextVNode(),
                            _createElementVNode("span", _hoisted_69, _toDisplayString(itemL), 1),
                            _createTextVNode(),
                            _hoisted_70
                          ]))
                        }), 128)),
                        _hoisted_71,
                        _createElementVNode("span", null, _toDisplayString(_ctx.selectedLastWorkTimeFilter_unavail.length) + " items selected", 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.filterColumn_unavail == 'Next Assignment Time')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.checkAllNextAssigmentTimeFilter())),
                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.isCheckAllNextAssignTimeFilter_unavail) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.isCheckAllNextAssignTimeFilter_unavail]
                        ]),
                        _hoisted_72,
                        _hoisted_73,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lstNextAssignmentTime_unavail, (itemN, index) => {
                          return (_openBlock(), _createElementBlock("span", { key: index }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: itemN,
                              "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.selectedNextAssignementTimeFilter_unavail) = $event)),
                              onChange: _cache[38] || (_cache[38] = ($event: any) => (_ctx.updateCheckAllNextAssignTimeFilter()))
                            }, null, 40, _hoisted_74), [
                              [_vModelCheckbox, _ctx.selectedNextAssignementTimeFilter_unavail]
                            ]),
                            _createTextVNode(),
                            _createElementVNode("span", _hoisted_75, _toDisplayString(itemN), 1),
                            _createTextVNode(),
                            _hoisted_76
                          ]))
                        }), 128)),
                        _hoisted_77,
                        _createElementVNode("span", null, _toDisplayString(_ctx.selectedNextAssignementTimeFilter_unavail.length) + " items selected", 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 7,
                  title: "Value",
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.filterText_unavail) = $event)),
                  class: "neu-input mb-2 filterInput",
                  type: "text"
                }, null, 512)), [
                  [_vModelText, _ctx.filterText_unavail]
                ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "submit",
            title: "Filter",
            class: "neu-button--primary neu-button neu-button--raised filterBtn",
            onClick: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.onGridFilter && _ctx.onGridFilter(...args)))
          }, "Filter"),
          _createElementVNode("button", {
            type: "reset",
            title: "Clear",
            class: "neu-button--primary neu-button neu-button--raised filterBtn",
            onClick: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.onGridFilterClear && _ctx.onGridFilterClear(...args)))
          }, "Clear"),
          _createElementVNode("button", {
            type: "button",
            title: "Close",
            class: "neu-button--primary neu-button neu-button--raised filterBtn",
            onClick: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.onGridFilterClose && _ctx.onGridFilterClose(...args)))
          }, "Close")
        ])
      ])
    ], 512), [
      [_vShow, _ctx.filterVisibleOnGrid == 'unavail']
    ]),
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowExportToExcel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
          _createVNode(_component_ExportToExcelForTabs, {
            onCloseExcelTemplate: _ctx.closeUnscheduledTabExportToExcel,
            payloadExportToExcel: _ctx.payloadExportToExcel
          }, null, 8, ["onCloseExcelTemplate", "payloadExportToExcel"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}